
import UserService from "@/services/user.service";
import AdminService from "@/services/admin.service.js";

/**
 * @classdesc Un remboursement sur une inscription
 * @kind class
 * @export
 * @prop {type} prop - Prop desc
 * @class Inscription_Refund
 */
export default class Inscription_Refund {
    id;
    id_inscription;
    id_commande_inscription;
    amount_refundable = 0;
    amount_to_refund = 0;
    amount_after_refund = 0;
    action = "refund_and_delete";
    error = "";
    /**
     * Creates an instance of Inscription_Refund.
     * @constructs
     * @kind function
     * @memberof Inscription_Refund
     */
    constructor() { }


    init(inscription) {
        this.id_inscription = inscription.id;
        this.id_commande_inscription = inscription.commande_inscription.id;
        this.setAmountRefundable(inscription);

    }

    setAmountRefundable(inscription) {
        let amount_refundable = 0;
        if (this.action != 'refund_with_gia') {
            inscription.commande_options.forEach((option) => {
                amount_refundable += parseFloat(option.prix);
            });
        }

        amount_refundable += parseFloat(inscription.commande_inscription.prix);
        if (inscription.code_reduction && inscription.code_reduction.valeur != null) {
            amount_refundable += parseFloat(inscription.code_reduction.valeur);
        }
        if (inscription.refunds && inscription.refunds.length > 0) {
            inscription.refunds.forEach((refund) => {
                amount_refundable -= parseFloat(refund.amount_refunded);
            });
        }
        if (amount_refundable < 0) amount_refundable = 0;
        this.amount_refundable = amount_refundable;
        this.amount_to_refund = amount_refundable;
    }

    updateAmountToRefund() {

        this.amount_after_refund = parseFloat(this.amount_refundable) - parseFloat(this.amount_to_refund);
        this.amount_after_refund = this.amount_after_refund.toFixed(2);
    }

    async proceedToRefund() {
        this.error = "";
        let request = await AdminService.makeRefund(this);
        if (!request) {
            this.error = "Une erreur est survenue lors du remboursement";
            return false;
        }
        if (request.data.error) {
            this.error = request.data.error;
            return false;
        }
        return request.data;
    }

    async user_refund_with_gia() {
        let request = await UserService.refundWithGIA(this);
        if (!request) {
            this.error = "Une erreur est survenue lors du remboursement";
            return false;
        }
        if (request.data.error) {
            this.error = request.data.error;
            return false;
        }
        return request.data;
    }

    set(data) { }
}